export default "__VITE_ASSET__502c5f10__"